import Placeholder from '@components/Placeholder';
import { useAuth } from '@context/AuthContext';
import useTranslation from '@helpers/useTranslation';
import { Link } from 'gatsby';
import React, { FC, Fragment } from 'react';
import { Menu } from 'react-bulma-components';
import * as constants from '../../constants';

const DashboardTemplateMenu: FC = () => {
  const { t } = useTranslation('dashboard');

  const { authClient, isReady } = useAuth();

  const PlaceholderWrapper = isReady ? Fragment : Placeholder;

  const activeClassName = isReady ? 'is-active' : undefined;

  return (
    <Menu>
      <Menu.List title={<PlaceholderWrapper>{t('settings')}</PlaceholderWrapper>}>
        <Menu.List.Item
          activeClassName={activeClassName}
          partiallyActive
          renderAs={Link}
          to={constants.DASHBOARD_PROFILE_PAGE}
        >
          <PlaceholderWrapper>{t('profile')}</PlaceholderWrapper>
        </Menu.List.Item>
      </Menu.List>
      <Menu.List title={<PlaceholderWrapper>{t('billing')}</PlaceholderWrapper>}>
        <Menu.List.Item
          activeClassName={activeClassName}
          partiallyActive
          renderAs={Link}
          to={constants.DASHBOARD_SUBSCRIPTION_PAGE}
        >
          <PlaceholderWrapper>{t('subscription')}</PlaceholderWrapper>
        </Menu.List.Item>
        <Menu.List.Item
          activeClassName={activeClassName}
          partiallyActive
          renderAs={Link}
          to={constants.DASHBOARD_INVOICES_PAGE}
        >
          <PlaceholderWrapper>{t('invoices')}</PlaceholderWrapper>
        </Menu.List.Item>
      </Menu.List>
      <Menu.List title={<PlaceholderWrapper>{t('account')}</PlaceholderWrapper>}>
        <Menu.List.Item onClick={authClient.logout}>
          <PlaceholderWrapper>{t('logOut')}</PlaceholderWrapper>
        </Menu.List.Item>
      </Menu.List>
    </Menu>
  );
};

export default DashboardTemplateMenu;
